'use client';
import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { useTranslations } from 'next-intl';
import { LayoutContext, useLayoutContext } from '@/context/LayoutContext';
import CookieFunction from '@/functions/cookieFunction';
// import config from '@/api/global';
import MoreBox from '@/components/general/MoreBox';
// import { routing } from '@/i18n/routing';
import { usePathname, useRouter } from 'next/navigation';
import { useShowModal } from '@/functions/useShowModal';
import { useRouterPath } from '@/functions/routerPath';
import config, { TRIGGERS } from '@/api/global';
import AppLink from '@/components/common/AppLink';
import Button from '@/components/common/Button';
import MainIcons from '@/icons/main';
import Logo from '@/components/general/Logo';
import ToolbarSearch from '@/components/common/ToolbarSearch';
import Modal from '../Modal';
import modalStyles from '@/components/Modals/ModalsContainer/styles.module.css';
import MenuItem from './MenuItem';
import LogoSection from './LogoSection';
import { CarSwitcher } from '@/components/pages/home/HomeContent/CarSwitcher';
import ArrowIconRotate from '@/components/pages/home/HomeContent/CarSwitcher/PlateBadge/ArrowIconRotate';
import UserAvatar from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo/UserAvatar';
import { UserMenu } from './UserMenu';

type ToolbarType = {
  toggleMenuFunction?: () => void;
  locale?: string;
  innerClass?: string;
  page?: 'normal' | '404';
};

export default function Toolbar({
  toggleMenuFunction,
  locale,
  innerClass,
  page = 'normal',
}: ToolbarType) {
  const t = useTranslations('common');
  const router = useRouter();
  const pathname = usePathname();
  const showModal = useShowModal();
  const routerPath = useRouterPath();
  console.log('config==', config.udata);
  const {
    trigger,
    setTrigger,
    dir,
    setMode,
    mode,
    login,
    logoutFunction,
    totalCount,
    isLogin,
    toolbarMenuList,
    switchLanguage,
    activeCar,
    userInfo,
  } = useLayoutContext();

  const toolbarIconList: any = [
    // {
    //   id: 'locale',
    //   // icon: <ToolbarIcons.LanguageIcon className={styles.icon} />,
    //   icon: (
    //     <MoreBox
    //       className={`${styles.lang_toggle} ${styles.icon}`}
    //       icon={
    //         <>
    //           <MainIcons.notifIcon fill="var(--brand-pale)" /> <span>{locale}</span>
    //         </>
    //       }
    //       id={'languageBox'}
    //       selected={locale}
    //       boxClassName={``}
    //       list={config?.Langs?.map((x) => {
    //         return {
    //           ...x,
    //           title: t(`${x.title}`),
    //           onClick: (item: any) => {
    //             switchLanguage(item?.id);
    //           },
    //         };
    //       })}
    //     />
    //   ),
    //   title: locale,
    // },
    Number(process.env.version) > 1 && {
      id: 'basket',
      title: 'basket',
      icon: (
        <div
          className={`${styles.icon} relative`}
          onClick={() => {
            setTrigger(TRIGGERS.BASKETMODAL);
          }}
        >
          <MainIcons.basketIcon />
          {totalCount != undefined && totalCount != 0 && (
            <span className={`${styles.cartCount}`}>{totalCount}</span>
          )}
        </div>
      ),
    },
  ];

  const changeMode = (item: { id: string }) => {
    console.log('item==', item);
    setMode(item?.id);
    CookieFunction('set', config.modeName, item?.id, 365);
  };
  console.log('mode==', mode);

  const [isLight, setIsLight] = useState(false);

  useEffect(() => {
    const sections = Array.from(document.querySelectorAll('section'));

    const updateTheme = () => {
      const toolbarOffset = 80; // adjust to your toolbar height
      let activeSection = null;

      for (const section of sections) {
        const rect = section.getBoundingClientRect();

        // Pick the section that is currently under the toolbar
        if (rect.top <= toolbarOffset && rect.bottom > toolbarOffset) {
          activeSection = section;
          break;
        }
      }

      if (activeSection) {
        setIsLight(activeSection.getAttribute('data-nav-theme') === 'light');
      } else {
        setIsLight(false);
      }
    };

    updateTheme();
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      window.addEventListener('scroll', updateTheme, { passive: true });
      window.addEventListener('resize', updateTheme);
    }

    return () => {
      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        window.removeEventListener('scroll', updateTheme);
        window.removeEventListener('resize', updateTheme);
      }
    };
  }, []);

  const rendersearch = () => (
    <ToolbarSearch
    // wrapperInput={`${styles.wrapperInput}`}
    // className={`${styles.searchContainer}`}
    // placeholder={`${t('fullsearchplaceholder')}`}
    />
  );
  console.log('isLogin========', isLogin);
  const renderSignin = () => (
    <>
      {!isLogin ? (
        <div className={`${styles.buttonContainer}`}>
          {/* <div
            className={`${styles.signButton}`}
            onClick={() => {
              setTrigger(TRIGGERS.LOGIN_MODAL);
            }}
          >
            <Button className="btn btn-ghost">{t('signin')}</Button>
          </div> */}
          <AppLink href="/login" title={`${t('signin')}`} className={`${styles.signButton}`}>
            <Button className="btn btn-ghost">{t('signin')}</Button>
          </AppLink>
          {/* <AppLink href="/signup" title={`${t('signup')}`} className={`${styles.signButton}`}>
            <Button className="btn btn-primary">{t('signup')}</Button>
          </AppLink> */}
        </div>
      ) : (
        <MoreBox
          className={`${styles.lang_toggle} ${styles.icon}  ${styles.userIcon}`}
          activeStyle={`activeMoreBoxButton`}
          icon={
            <>
              <UserAvatar
                name={userInfo?.name?.trim()?.slice(0)}
                colorNumber={0}
                avatarClass={styles.avatarBadge}
              />
              <ArrowIconRotate />
            </>
          }
          id={'userMenu'}
          boxClassName={`${styles.userMenuWrapper}`}
        >
          <UserMenu />
        </MoreBox>
      )}
    </>
  );
  const renderSigninMobile = () => (
    <>
      {!isLogin ? (
        <MenuItem
          item={{
            id: 'login',
            title: t('signin'),
            href: '/login',
            // onClick: () => setTrigger(TRIGGERS.LOGIN_MODAL),
            parent: 'login',
          }}
        >
          {/* <MainIcons.userIcon /> */}
        </MenuItem>
      ) : (
        // <MenuItem
        //   item={{
        //     id: 'profile',
        //     title: t('profile'),
        //     href: '/dashboard',
        //     parent: 'profile',
        //   }}
        // />
        <></>
      )}
    </>
  );
  console.log('pathname==', pathname);
  return (
    <>
      <header className={`${styles.nav}  ${isLight ? styles.light : ''}`}>
        <div className={`wrap ${styles.nav_inner} ${innerClass}`}>
          <div className={`${styles.logoPart}`}>
            <LogoSection />
          </div>
          {page == 'normal' && <div className={`${styles.desktopSearch}`}>{rendersearch()}</div>}
          {page == 'normal' && (
            <div className={`${styles.searchPart}`}>
              <nav className={`${styles.nav__links} ${styles.nav__menu}`}>
                {toolbarMenuList?.map(
                  (item, index) =>
                    item && (
                      <AppLink
                        key={index}
                        title={item?.title}
                        href={item?.href}
                        className={`${styles.navLink} ${pathname.includes(item?.parent) && styles.active}`}
                      >
                        {item?.title}
                      </AppLink>
                    ),
                )}
              </nav>
              {isLogin && <CarSwitcher />}

              <nav className={`${styles.nav__actions}`}>
                {toolbarIconList?.length != 0 &&
                  toolbarIconList?.map((item: any, index: number) => (
                    <div key={index} className={`${styles.changeModeIcon}`}>
                      {item?.icon}
                    </div>
                  ))}
                <div className={`${styles.signinDesktop}`}>{renderSignin()}</div>
                <Button
                  className={`btn icon-btn ${styles.menuIcon} ${styles.menuButton}`}
                  onClick={() => {
                    setTrigger(TRIGGERS.MOBILEMENU);
                  }}
                >
                  <MainIcons.menuIcon />
                </Button>
              </nav>
            </div>
          )}
        </div>
      </header>
      {trigger == TRIGGERS.MOBILEMENU && (
        <Modal
          handleShowModal={() => {
            setTrigger('');
          }}
          title={<LogoSection />}
          extraContentStyle={modalStyles.basketModalContent}
          extraHeaderStyle={modalStyles.cartExtraHeaderStyle}
          modalKey={TRIGGERS.MOBILEMENU}
          extrawrapperstyle={modalStyles.basketModalExtrawrapperstyle}
        >
          <div className={`${styles.mobileSearch}`}>{rendersearch()}</div>
          <div className={`${modalStyles.menuList}`}>
            {toolbarMenuList?.map((item, index) => (
              <>
                {item && (
                  <MenuItem item={item} key={index} active={pathname.includes(item?.parent)} />
                )}
              </>
            ))}
            {isLogin && (
              <MenuItem item={{ id: 'logout', onClick: logoutFunction, title: t('logout') }} />
            )}
            {/* {<div className={`${styles.signupMobile}`}>{renderSigninMobile()}</div>} */}
          </div>
        </Modal>
      )}
    </>
  );
}
